import { useLocation, Link } from "react-router-dom";
import LeadFormModal from "@/pages/lead_inventory/LeadFormModal";
import PageSubHeader from "./pageSubHeader.jsx";

import logo from "../assets/MMlogo.png";
import { toast } from "react-toastify";

const PageHeader = () => {
  const location = useLocation();
  const role = localStorage.getItem("role");
  const user = Number(localStorage.getItem("userId"));
  const email = localStorage.getItem("email");

  let isAdmin = false;
  let isHunter = false;
  let isHeadHunter = false;
  let isFarmer = false;
  let isHeadFarmer = false;

  if (role) {
    if (role === "Admin") {
      isAdmin = true;
    } else if (role === "Farmer") {
      if (user === 19) {
        isHeadFarmer = true;
      }
      isFarmer = true;
    } else {
      if (user === 21) {
        isHeadHunter = true;
      }
      isHunter = true;
    }
  }

  const getTitle = () => {
    if (location.pathname === "/home") return "Dashboard";
    if (location.pathname === "/leadDistribution") return "Lead Distribution";
    if (
      location.pathname === "/lead_inventory/yours" ||
      location.pathname === "/lead_inventory/all" ||
      location.pathname === "/lead_inventory/shark_tank"
    )
      return "Lead Inventory";
    if (
      location.pathname === "/account_distribution/incoming" ||
      location.pathname === "/account_distribution/assigned"
    )
      return "Accounts Distribution";
    if (
      location.pathname === "/account_inventory/yours" ||
      location.pathname === "/account_inventory/all"
    )
      return "Accounts Inventory";
    if (
      location.pathname === "/opportunity_inventory/yours" ||
      location.pathname === "/opportunity_inventory/all"
    )
      return "Opportunity Inventory";
    if (location.pathname === "/admin") return "Admin";
    if ("/lead_journey?lead_id=".includes(location.pathname))
      return "Lead / Lead Journey Pipeline";
    if ("/account_details?lead_id=".includes(location.pathname))
      return "Accounts / Account Details";
  };

  // const handleNewLeadClick = () => {
  //   setShowModal(true);
  //   <LeadFormModal isOpen={showModal} onClose={() => setShowModal(false)}/>
  //   // toast.success("New Lead Clicked");
  // };

  const isLead =
    [
      "/lead_inventory/yours",
      "/lead_inventory/all",
      "/lead_inventory/shark_tank",
    ].includes(location.pathname) || location.pathname === "/lead_journey";
  const isAccDistribution = [
    "/account_distribution/incoming",
    "/account_distribution/assigned",
  ].includes(location.pathname);
  const isAccInventory =
    ["/account_inventory/yours", "/account_inventory/all"].includes(
      location.pathname
    ) || location.pathname === "/account_details";
  const isOpportunity = [
    "/opportunity_inventory/yours",
    "/opportunity_inventory/all",
  ].includes(location.pathname);

  const showBackButton = ("/lead_journey?lead_id=",
  "/account_details?lead_id=").includes(location.pathname);

  return (
    <div className="sticky top-0 bg-white shadow z-40">
      <nav className="flex items-center justify-between px-8 pt-2">
        <div className="flex items-center">
          <div className="text-lg font-bold">
            <Link to="/home" className="flex items-center space-x-2">
              <div className="w-36 h-16 rounded-xl flex items-center justify-center">
                <img
                  src={logo}
                  alt="Logo"
                  className="Logo h-12 object-contain"
                />
              </div>
              <b className="text-gray-500">CSP</b>
              <span className="text-gray-500">4.0</span>
            </Link>
          </div>
          {email && <div className="text-gray-400 text-sm ml-2">{email}</div>}
        </div>
        <div className="flex space-x-6 font-bold">
          <Link
            to="/home"
            className={`hover:text-yellow-300 ${
              location.pathname === "/home"
                ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                : "text-gray-400 font-bold"
            }`}
          >
            Home
          </Link>
          {(isHunter || isAdmin) && (
            <>
              {/* {(isHeadHunter || isAdmin) && (
              <Link
                to="/leadDistribution"
                className={`hover:text-yellow-300 ${
                  location.pathname === "/leadDistribution"
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                Lead Distribution
              </Link>
            )} */}
              <Link
                to="/lead_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isLead
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                Leads
              </Link>
            </>
          )}
          {(isFarmer || isAdmin) && (
            <>
              {(isHeadFarmer || isAdmin) && (
                <Link
                  to="/account_distribution/incoming"
                  className={`hover:text-yellow-300 ${
                    isAccDistribution
                      ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                      : "text-gray-400"
                  }`}
                >
                  Accounts Distribution
                </Link>
              )}
              <Link
                to="/account_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isAccInventory
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400"
                }`}
              >
                Accounts
              </Link>
              <Link
                to="/opportunity_inventory/yours"
                className={`hover:text-yellow-300 ${
                  isOpportunity
                    ? "pb-2 border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400"
                }`}
              >
                Opportunities
              </Link>
            </>
          )}
        </div>
      </nav>
      <div className="">
        <PageSubHeader
          title={getTitle()}
          role={role} // pass role as props here
          showBackButton={showBackButton}
        />
      </div>
    </div>
  );
};

export default PageHeader;
